import { findRouteEntry } from '@/config/navigation/routeMap';
import { env } from '@/env/env';
import { useLocation } from 'react-router';

import { NotFoundScreen } from '../ui/NotFoundScreen';
import LegacyModuleFrame from './LegacyModuleFrame';

const baseHostName = window.location.origin;
const shiplexBaseUrl = (env.VITE_SHIPLEX_BASE_URL ?? baseHostName) + env.VITE_SHIPLEX_LEGACY_APP_ROUTE;

export default function LegacyRouteResolver() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const mode = searchParams.get('mode');

  if (mode !== null) {
    // Primary: ?mode= query param (used by nav menu links)
    searchParams.delete('mode');
    const extraParams = searchParams.toString();
    const qs = extraParams ? `&${extraParams}` : '';
    const src = `${shiplexBaseUrl}?mode=${mode}${qs}`;
    return <LegacyModuleFrame src={src} />;
  }

  // Fallback: resolve from path using JSON nav config route map
  const routeEntry = findRouteEntry(location.pathname);
  if (routeEntry !== undefined) {
    const configQs = routeEntry.qs ? `&${routeEntry.qs}` : '';
    const src = `${shiplexBaseUrl}?mode=${routeEntry.mode}${configQs}`;
    return <LegacyModuleFrame src={src} />;
  }

  return <NotFoundScreen />;
}
